var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75248 0.271077L11.9215 2.44008C12.0929 2.61119 12.1894 2.84327 12.19 3.08546C12.1905 3.32764 12.0951 3.56017 11.9245 3.73208L5.14648 10.5611L2.11148 11.2221C1.96158 11.2545 1.80596 11.2487 1.65884 11.2054C1.51172 11.1621 1.37782 11.0826 1.26938 10.9742C1.16094 10.8657 1.08142 10.7318 1.03812 10.5847C0.994809 10.4376 0.98909 10.282 1.02148 10.1321L1.68248 7.10108L8.45248 0.271077C8.53762 0.18533 8.63889 0.117277 8.75045 0.0708368C8.862 0.0243969 8.98165 0.000488281 9.10248 0.000488281C9.22332 0.000488281 9.34296 0.0243969 9.45452 0.0708368C9.56608 0.117277 9.66734 0.18533 9.75248 0.271077ZM1.5 12.9997C1.22386 12.9997 1 13.2236 1 13.4997C1 13.7758 1.22386 13.9997 1.5 13.9997H12.5C12.7761 13.9997 13 13.7758 13 13.4997C13 13.2236 12.7761 12.9997 12.5 12.9997H1.5Z",
    fill: "#006A76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5753b72e224c5dcff72cecedc408677e.svg";
export { ForwardRef as ReactComponent };